import { isNull, isUndefined, toPairs } from 'lodash'
import URLSearchParams from 'url-search-params'

export const parseUrlParameter = parameterDict => {
  const params = toPairs(parameterDict)
    .map(parameter => parameter.join('='))
    .join('&')

  return params ? `?${params}` : ``
}

export const urlQueryObject = uri => {
  const url = new URL(uri)
  const params = new URLSearchParams(url.search.slice(1))

  const dict = {}
  params.forEach((v, k) => {
    if (/\[\]/.test(k)) {
      // []がkeyに含まれる場合、配列で渡ってくるものなので配列としてハッシュにいれる
      ;(dict[k] = dict[k] || []).push(v)
    } else if (k in dict) {
      // すでにdict[k]が存在する場合は、配列にpushする
      ;(Array.isArray(dict[k]) ? dict[k] : (dict[k] = [dict[k]])).push(v)
    } else {
      dict[k] = v
    }
  })

  return dict
}

export const updateUrlQuery = (uri, key, value) => {
  const query = urlQueryObject(uri)
  if (isNull(value)) {
    // NOTE: undefinedの場合は値を空で保存する
    query[key] = ''
  } else if (isUndefined(value)) {
    // NOTE: undefinedの場合は値を削除する
    delete query[key]
  } else {
    query[key] = value
  }

  const url = new URL(uri)
  url.search = new URLSearchParams(query)
  return url.href
}

export default class UrlUtil {
  // URLクエリを更新した文字列を返します
  static updateUrlParameter(key, value, uri) {
    const newUri = uri || window.location.href

    const parameterDict = this.getUrlParameterDict(newUri)
    parameterDict[key] = value

    const url = new URL(newUri)
    return `${url.origin + url.pathname}${parseUrlParameter(parameterDict)}${url.hash}`
  }

  // URLクエリから、引数の `key` に該当する値を取得し返します
  static getUrlParameter(key, uri) {
    const newUri = uri || window.location.href

    const parameterDict = this.getUrlParameterDict(newUri)
    return parameterDict[key]
  }

  // URLクエリ文字列をオブジェクトにして返します
  static getUrlParameterDict(uri) {
    return urlQueryObject(uri || window.location.href)
  }

  // URLのPath部分を返す
  static getUrlPathname(uri) {
    const newUri = uri || window.location.href

    const url = new URL(newUri)
    return url.pathname
  }
}
